// extracted by mini-css-extract-plugin
export default {"AcknowledgeSendEmailContainer":"AcknowledgeSendEmail_AcknowledgeSendEmailContainer__wp85S"};